import {ssrGetGamesForEStoreProductDetail} from '~/graphql/operations/game/game-detail-for-estore-product-detail.generated';

async function getContentGameOnContentFull(sku: string, locale?: string) {
  const {
    props: {data},
  } = await ssrGetGamesForEStoreProductDetail.getServerPage(
    {
      variables: {
        locale,
        sku,
      },
    },
    {}
  );
  return data?.gameCollection?.items || [];
}

export default getContentGameOnContentFull;
